import { cn as classJoin } from "../../lib/utils";

const TONE = {
    slate: "text-slate-900",
    emerald: "text-emerald-700",
    rose: "text-rose-700",
    amber: "text-amber-700",
    indigo: "text-indigo-700",
};

export default function KpiTile({ label, value, sub, icon, tone = "slate", testid }) {
    return (
        <div className="reedos-card p-4" data-testid={testid}>
            <div className="reedos-eyebrow flex items-center gap-1.5">{icon} {label}</div>
            <div className={classJoin("font-display font-bold reedos-data text-2xl mt-1", TONE[tone])}>{value}</div>
            {sub && <div className="text-[11px] text-slate-500 mt-0.5">{sub}</div>}
        </div>
    );
}
